module.exports = __webpack_public_path__ + "static/media/zero-banner-en.348de201.png";